import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { EmptyRow } from 'console/table/empty-row';
import { TableWithMobileView } from 'console/table/table-with-mobile-view';
import { prettyFloat, unixToDate } from 'utils';
import { nnbsp } from 'console/utils/chars';
export const HistoryMaintenanceTable = memo(function HistoryMaintenanceTable(props) {
    const { device_maintenances, onEditHistoryMaintenance } = props;
    const history = useMemo(() => (device_maintenances != null ? device_maintenances.history : []), [device_maintenances?.history]);
    const onClickRow = useCallback((maintenance) => () => {
        onEditHistoryMaintenance(maintenance);
    }, [onEditHistoryMaintenance]);
    return (_jsx(TableContainer, { sx: { maxHeight: 450 }, children: _jsxs(TableWithMobileView, { stickyHeader: true, children: [_jsx(TableHead, { children: _jsx(TableRow, { children: ['Дата', 'Название', 'Пробег', 'Моточасы'].map((label) => (_jsx(TableCell, { padding: "normal", variant: "head", children: _jsx("strong", { children: label }) }, label))) }) }), _jsx(TableBody, { children: history.length !== 0 ? (history
                        .sort(({ performed: performed_a }, { performed: performed_b }) => {
                        if (performed_a.date && performed_b.date) {
                            if (performed_a.date < performed_b.date) {
                                return 1;
                            }
                            else if (performed_a.date > performed_b.date)
                                return -1;
                        }
                        return 0;
                    })
                        .map((maintenance, i) => {
                        const { name, performed } = maintenance;
                        const { date, mileage, moto_hours } = performed;
                        return (_jsxs(TableRow, { onClick: onClickRow(maintenance), hover: true, children: [_jsx(TableCell, { children: date != null ? unixToDate(date) : '???' }), _jsx(TableCell, { children: name }), _jsx(TableCell, { children: mileage != null
                                        ? `${prettyFloat(mileage / 1e3, 1)}${nnbsp}т.км`
                                        : '???' }), _jsx(TableCell, { children: prettyFloat(moto_hours, 1) })] }, i));
                    })) : (_jsx(EmptyRow, { title: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0422\u041E \u043F\u0443\u0441\u0442\u0430", colSpan: 4 })) })] }) }));
});
